import React from 'react';
import ShopPage from './ShopPage';

const ShopPageTCG = () => {
  return <ShopPage collectionName="shopItemsTCG-v2" />;
};

export default ShopPageTCG;
